import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BTab, BTabs } from "bootstrap-vue";
import { computed } from "vue";
import {} from "@/api/jobs";
import { getHeaderClass, iconClasses } from "@/composables/useInvocationGraph";
import JobDetailsDisplayed from "../JobInformation/JobDetails.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobStep',
    props: {
        jobs: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const firstJob = computed(() => props.jobs[0]);
        const jobCount = computed(() => props.jobs.length);
        function getIcon(job) {
            return iconClasses[job.state];
        }
        function getTabClass(job) {
            return {
                ...getHeaderClass(job.state),
                "d-flex": true,
                "text-center": true,
            };
        }
        return { __sfc: true, props, firstJob, jobCount, getIcon, getTabClass, FontAwesomeIcon, BAlert, BTab, BTabs, JobDetailsDisplayed };
    }
});
